module.exports = __webpack_public_path__ + "images/PDF_smallIcon.svg";